import { Modal } from 'antd';
import styled from 'styled-components';

import { Button } from '../_atoms/Button';

interface InternationalSchoolModalProps {
  open: boolean;
  onAnswer: (mode: 'yes' | 'no') => void;
  // Render above another antd Modal — caller sets this when the modal lives
  // inside the onboarding flow (which is itself an antd Modal).
  zIndex?: number;
}

/**
 * One-time prompt shown the first time a non-native-English teacher picks
 * English / Literacy as a subject. Used both on the home page subject
 * dropdown and during onboarding so both surfaces keep the same wording,
 * styling, and behaviour.
 *
 * The caller persists the answer (typically via writeIntlSchoolMode) and
 * advances/closes whatever flow the modal interrupted.
 */
export function InternationalSchoolModal({
  open,
  onAnswer,
  zIndex,
}: InternationalSchoolModalProps) {
  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      maskClosable={false}
      centered
      width={460}
      zIndex={zIndex}
    >
      <Content>
        <h3>Tell us about your school</h3>
        <p>
          Many teachers outside the US work at international schools that follow an
          English curriculum. Where do you teach?
        </p>
        <Buttons>
          <Button onClick={() => onAnswer('yes')}>
            International school (English curriculum)
          </Button>
          <Button type="ghost" onClick={() => onAnswer('no')}>
            Local school
          </Button>
        </Buttons>
      </Content>
    </Modal>
  );
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 4px 0;

  h3 {
    margin: 0;
    font-size: 20px;
    color: #2f2417;
  }

  p {
    margin: 0;
    color: #5e4b38;
    line-height: 1.45;
  }
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
